export default {
  TableSort(tmpData, column) {
    tmpData.sort((a, b) => {
      let v1 = getValue(a, column.prop)
      let v2 = getValue(b, column.prop)

      // 将空白字符串转换为特殊标记值
      if (v1 === '') {
        v1 = '~'
      }
      if (v2 === '') {
        v2 = '~'
      }

      // 检查排序顺序，升序或降序
      let isAscending = column.order === 'ascending'

      // 特殊处理空白值和0的比较
      if (v1 === '~') return isAscending ? -1 : 1
      if (v2 === '~') return isAscending ? 1 : -1

      // 利用逻辑运算符简化比较过程

      if (typeof v1 === 'string' && typeof v2 === 'string') {
        return isAscending ? v1.localeCompare(v2, 'zh-Hans-CN') : v2.localeCompare(v1, 'zh-Hans-CN')
      } else {
        return isAscending ? v1 - v2 : v2 - v1
      }
    })
  }
}

// 判断是否是数字类型
function getValue(item, prop) {
  let value = item[prop]
  if (typeof value !== 'number') {
    value = value || ''
    value = value.toLowerCase()
  }
  return value
}
